module.exports = __webpack_public_path__ + "img/xmfs.f9dae99c.png";